interface ICollapse {
    id: string;
    children: React.ReactNode;
}

const Collapse = ({ id, children }: ICollapse) => {
    return (
        <div
            className='accordion d-flex flex-column gap-2'
            id={id}
        >
            {children}
        </div>
    );
};

export default Collapse;
